import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';
import { KeyboardEvent } from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { DirectFormInput } from '../../components/DirectFormInput/DirectFormInput';
import { InputFieldType } from '../../components/InputField/InputField';
import { Bem } from '../../service/Bem/Bem';

import './ProductsSearchForm.css';
import * as keyset from './ProductsSearchForm.i18n';

const BLOCK = 'products-search-form';

const i18n = i18nFactory(keyset);

interface ProductsSearchFormProps {
    onSearch: (searchInput: string) => void;
}

interface ProductsSearchFormState {
    searchInput: string;
}

export class ProductsSearchForm extends React.Component<
    ProductsSearchFormProps,
    ProductsSearchFormState
> {
    state = {
        searchInput: ''
    };

    render() {
        return (
            <div className={Bem.cls(BLOCK)}>
                <DirectFormInput
                    theme={'normal'}
                    size={'s'}
                    text={this.state.searchInput}
                    cls={Bem.cls(BLOCK, 'input')}
                    inputType={InputFieldType.TEXT}
                    hasClear={true}
                    onChange={this.onChange}
                    placeholder={i18n('placeholder')}
                    onKeyDown={this.onKeyDown}
                />
                <ButtonDecorator
                    onClick={this.onSearch}
                    theme={'normal'}
                    text={i18n('search')}
                    size={'s'}
                />
            </div>
        );
    }

    private onChange = (searchInput: string) => {
        this.setState({ searchInput });

        if (!searchInput) {
            this.props.onSearch('');
        }
    };

    private onSearch = () => this.props.onSearch(this.state.searchInput);

    private onKeyDown = (key: KeyboardEvent<HTMLInputElement>) => {
        if (key.keyCode === 13) {
            this.props.onSearch(this.state.searchInput);
        }
    };
}
